import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";

const Internship = ({ details, darkTheme }) => {
  return (
    <>
      <div className="internships__box">
        <h2>
          <p>{details.companyName}</p>
          <p>{details.role}</p>
        </h2>
        <h3>
          <FontAwesomeIcon
            icon={faCalendarDays}
            className="internships__calendar"
            style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
          />
          &nbsp; &nbsp;{details.duration}
        </h3>
        <ul>
          <p>{details.introText}</p>
          <li
            data-aos="fade-right"
            data-aos-delay="200"
            data-aos-offset={details.offsetValue}
            style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
          >
            <span
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              {details.keyPointOne}
            </span>
          </li>
          <li
            data-aos="fade-right"
            data-aos-delay="400"
            data-aos-offset={details.offsetValue}
            style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
          >
            <span
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              {details.keyPointTwo}
            </span>
          </li>
          <li
            data-aos="fade-right"
            data-aos-delay="600"
            data-aos-offset={details.offsetValue}
            style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
          >
            <span
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              {details.keyPointThree}
            </span>
          </li>
          <li
            data-aos="fade-right"
            data-aos-delay="800"
            data-aos-offset={details.offsetValue}
            style={{ color: darkTheme ? "#00ffff" : "#ff6347" }}
          >
            <span
              style={{
                color: darkTheme ? "white" : "black",
                fontWeight: darkTheme ? "none" : 500,
              }}
            >
              {details.keyPointFour}
            </span>
          </li>
        </ul>
      </div>
    </>
  );
};

export default Internship;
